import {TextField as MuiTextField} from "@mui/material";

const DateField = ({config, value, onChange, onEnter, size}) => (
  <MuiTextField
    type="date"
    label={config.label}
    size={size}
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value)}
    onKeyDown={(e) => e.key === "Enter" && onEnter?.()}
    InputLabelProps={{shrink: true}}
    sx={{minWidth: config.width ?? 180}}
  />
);

export default DateField;
